import { useState } from "react";

function ToolTip(props) {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{ position: "relative" }}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={props.onClick}
    >
      {props.title && hover && (
        <div
          style={{
            zIndex: props?.zIndex,
            left: props?.left,
            right: props?.right,
            top: props?.top,
            bottom: props?.bottom,
            position: "absolute",
            ...props.style,
          }}
          className={props.className}
        >
          {props.title}
        </div>
      )}
      {props.children}
    </div>
  );
}

export default ToolTip;
